import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { createColumns } from "../../helpers";
import { DATATABLE_CUSTOM_STYLES } from "../../constants/datatableStyles";
import CustomPagination from "../../Components/CustomPagination";
import RowLoader from "../../Components/UI/RowLoader";
import { fetchWalletHistory } from "../../Redux/WalletHistoryList/walletAction";
import { clearWalletHistoryData } from "../../Redux/WalletHistoryList/walletSlice";

const WalletHistory = ({ currentTab }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Parse URL parameters
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const [searchTerm, setSearchTerm] = useState(queryParams.get("search") || "");
  const [currentPage, setCurrentPage] = useState(
    parseInt(queryParams.get("page"), 10) || 1
  );
  const [sortKey, setSortKey] = useState(queryParams.get("sortKey") || "");
  const [sortDirection, setSortDirection] = useState(
    queryParams.get("sortDirection") || "asc"
  );

  const { walletHistoryData, pagination, isLoading } = useSelector(
    (state) => state.WalletHistory
  );

  // Fetch data when dependencies change
  useEffect(() => {
    dispatch(
      fetchWalletHistory(
        currentTab,
        searchTerm,
        currentPage,
        sortKey,
        sortDirection
      )
    );
    return () => dispatch(clearWalletHistoryData());
  }, [currentTab, dispatch, searchTerm, sortKey, sortDirection, currentPage]);

  // Update URL parameters on change
  useEffect(() => {
    const params = new URLSearchParams();
    if (searchTerm) params.set("search", searchTerm);
    params.set("page", currentPage);
    if (sortKey) params.set("sortKey", sortKey);
    if (sortDirection) params.set("sortDirection", sortDirection);

    navigate({ search: params.toString() });
  }, [currentTab, searchTerm, currentPage, sortKey, sortDirection, navigate]);

  // Define table columns
  const hiddenColumns = ["action_by", "search_results"];
  const columns = useMemo(() => {
    return [...createColumns(walletHistoryData, [], hiddenColumns, true)].map(
      (col) => ({
        ...col,
        width: col.name === "Num" ? "70px" : "1fr",
        // sortable: [
        //   "Action Date",
        //   "Client Name",
        //   "Amount",
        //   "Notes",
        //   "Wallet Name",
        // ].includes(col.name),
        sortable: false,
      })
    );
  }, [walletHistoryData]);

  const handleSortChange = (column, direction) => {
    setSortKey(column.sortKey);
    setSortDirection(direction);
    setCurrentPage(1); // Reset to first page on sort change
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="bg-white shadow-lg rounded-lg flex flex-col tw-mb-5 tw-p-4">
      <input
        type="text"
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setCurrentPage(1);
        }}
        value={searchTerm}
        className="tw-border tw-border-blue-300 rounded-lg p-2 mb-2 w-full focus:tw-outline-blue-400"
        placeholder="Search by name, email and phone"
      />

      <DataTable
        columns={columns}
        data={walletHistoryData}
        customStyles={DATATABLE_CUSTOM_STYLES}
        progressPending={isLoading}
        onSort={handleSortChange}
        sortServer
        progressComponent={<RowLoader />}
      />

      <div className="flex justify-center mt-4">
        <CustomPagination
          totalPages={pagination?.last_page}
          currentPage={pagination?.current_page || 1}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default WalletHistory;
